var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { usaStateFromName } from "healthex-common/usaStates";
import { UserType } from "healthex-common/user.dtos";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { validators } from "../Logic/Validators";
import { FormModel } from "./FormModel";
export class WelcomeBasicOrgDetailsFormViewModel {
    constructor(opts) {
        this.formModel = new FormModel({
            name: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            logo: null,
        }, ["name", "address", "city", "state", "zip"]);
        this.organization = NOT_LOADED;
        this.organizationsManager = opts.container.organizationsManager;
        this.authManager = opts.container.authManager;
        void this.loadOrganization();
        this.onSave = opts.onSave;
        this.updateRequiredFields();
    }
    get isFormValid() {
        return this.formModel.isFormValid();
    }
    get isHealthcareOrg() {
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION;
    }
    get showUploadLogo() {
        return this.authManager.userType === UserType.EXTERNAL_RESEARCHER;
    }
    get description() {
        return this.isHealthcareOrg
            ? "This information is essential for account setup and ensures accurate representation within the HealthEx network."
            : "This information will be shown in communications and throughout the HealthEx experience, providing a personalized touch for your organization.";
    }
    updateRequiredFields() {
        this.formModel.requiredFields = ["name", "address", "city", "state", "zip"];
    }
    async loadOrganization(reload) {
        try {
            if (reload) {
                await this.organizationsManager.myOrganization.waitForReload();
            }
            else {
                await this.organizationsManager.myOrganization.waitForValue();
            }
            const organization = this.organizationsManager.myOrganization.value;
            if (organization === NOT_LOADED)
                return;
            if (!organization)
                return;
            this.organization = organization;
            const { name, logoUrl, address, city, state, zip } = organization;
            this.formModel.input = {
                ...this.formModel.input,
                name,
                logo: logoUrl,
                address: address !== null && address !== void 0 ? address : "",
                city: city !== null && city !== void 0 ? city : "",
                state: state !== null && state !== void 0 ? state : "",
                zip: zip !== null && zip !== void 0 ? zip : "",
            };
        }
        catch (e) {
            console.error(e);
        }
    }
    validateInput() {
        this.formModel.clearErrors();
        const { notBlank, notNull, validZIP } = validators;
        const f = this.formModel;
        f.validateField("name", notBlank, "Enter your organization's name");
        f.validateField("address", notBlank, "Enter an address");
        f.validateField("city", notBlank, "Enter a city");
        f.validateField("state", notNull, "Select a state from the list");
        f.validateField("zip", notBlank, "Enter a valid 5-digit ZIP code");
        f.validateField("zip", validZIP, "Enter a valid 5-digit ZIP code");
        return !f.hasErrors();
    }
    async save() {
        const success = await this.performUpdate();
        if (success) {
            await this.loadOrganization(true);
            this.onSave();
        }
    }
    async performUpdate() {
        if (this.organization === NOT_LOADED || this.organization === null)
            return false;
        if (!this.validateInput())
            return false;
        const { name, address, city, state, zip, logo } = this.formModel.input;
        const updatedOrganization = {
            type: this.organization.type,
            name,
            address,
            city,
            state: usaStateFromName(state),
            zip,
            logo,
        };
        await this.organizationsManager.editOrganization(this.organization.id, updatedOrganization);
        return true;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WelcomeBasicOrgDetailsFormViewModel.prototype, "organization", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBasicOrgDetailsFormViewModel.prototype, "isFormValid", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBasicOrgDetailsFormViewModel.prototype, "isHealthcareOrg", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBasicOrgDetailsFormViewModel.prototype, "showUploadLogo", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], WelcomeBasicOrgDetailsFormViewModel.prototype, "description", null);
